import { render, staticRenderFns } from "./MoneyTransferHeader.vue?vue&type=template&id=d032ccb4&"
import script from "./MoneyTransferHeader.vue?vue&type=script&lang=js&"
export * from "./MoneyTransferHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports